import { ChangeDetectorRef, Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core'
import { Store } from '@ngxs/store'
import { distinctUntilChanged } from 'rxjs'
import { UserState } from '../store'

/**
 * This directive shows or hides an element based on whether the user is a global admin
 */
@Directive({
  selector: '[ifGlobalAdmin]',
  standalone: true,
})
export class IfGlobalAdminDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private cdr: ChangeDetectorRef,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.store
      .select(UserState.isGlobalAdmin)
      .pipe(distinctUntilChanged())
      .subscribe(isGlobalAdmin => {
        if (isGlobalAdmin) {
          this.viewContainer.createEmbeddedView(this.templateRef)
        } else {
          this.viewContainer.clear()
        }
        // Note: Since this observable usually fires during a change detection loop. We need to manually detect
        // changes to prevent expression changed errors
        this.cdr.detectChanges()
      })
  }
}
